import { Box, useTheme, SxProps, Theme, IconButton, Slide } from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { useState, FC, useMemo } from "react"
import _ from "lodash"
import { deepmerge } from "@mui/utils"
import { getIcon } from "utils/icon"
import { EXTENSION_NAME } from "extensions/iconsiam/constants"
import { useExtension } from "hooks/extension/useExtension"

interface ISideBannerPanelProps {
  sx?: SxProps<Theme>
}

export const SideBannerPanel: FC<ISideBannerPanelProps> = ({ sx = {} }) => {
  const [open, setOpen] = useState(true)

  const theme = useTheme()
  const { root, triggerPanel, animationWrapper, contentContainer, iconButton } =
    theme.components?.[`SideBannerPanel`]?.styleOverrides || {}

  const isRtl = theme.isRtl

  const { extensionConfig } = useExtension()
  const { enable, triggerImage, contentImage } = _.get(
    extensionConfig,
    `${EXTENSION_NAME}.options.sideBannerPanel`,
    {}
  ) as { enable?: boolean; triggerImage?: string; contentImage?: string }

  const openIcon = useMemo(
    () => getIcon(theme?.assets?.nextIcon) || <ChevronRightIcon />,
    [theme]
  )

  const closeIcon = useMemo(
    () => getIcon(theme?.assets?.backIcon) || <ChevronLeftIcon />,
    [theme]
  )

  if (!enable) return null

  const triggerSx = triggerImage
    ? { ...triggerPanel, backgroundImage: `url('${triggerImage}')` }
    : triggerPanel

  const contentSx = contentImage
    ? { ...contentContainer, backgroundImage: `url('${contentImage}')` }
    : contentContainer

  return (
    <Box sx={deepmerge(root, sx)}>
      {!open && (
        <Box sx={triggerSx} onClick={() => setOpen(true)}>
          <IconButton className={isRtl ? "is-rtl" : ""} sx={iconButton}>
            {openIcon}
          </IconButton>
        </Box>
      )}

      {/* Banner Panel with Slide */}
      <Slide
        className={isRtl ? "is-rtl" : ""}
        direction={isRtl ? "left" : "right"}
        in={open}
        mountOnEnter
        unmountOnExit
        style={animationWrapper}
      >
        <Box
          sx={contentSx}
          className={isRtl ? "is-rtl" : ""}
          onClick={() => setOpen(false)}
        >
          <IconButton className={isRtl ? "is-rtl" : ""} sx={iconButton}>
            {closeIcon}
          </IconButton>
        </Box>
      </Slide>
    </Box>
  )
}
